// extracted by mini-css-extract-plugin
export default {"channels_component":"Channels_channels_component__QPUiV","channels":"Channels_channels__5mK6a","channel":"Channels_channel__ccFGB"};